import React from "react";

function NoteWarning() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4459_7092)">
        <path
          d="M2.90127 16.959H16.2161C16.4324 16.9589 16.6449 16.9028 16.833 16.796C17.021 16.6893 17.1782 16.5356 17.2891 16.3499C17.4 16.1642 17.4608 15.953 17.4656 15.7368C17.4704 15.5206 17.419 15.3068 17.3165 15.1164L10.6595 2.75313C10.1872 1.87656 8.93017 1.87656 8.45791 2.75313L1.80088 15.1164C1.69836 15.3068 1.64699 15.5206 1.6518 15.7368C1.65661 15.953 1.71742 16.1642 1.8283 16.3499C1.93918 16.5356 2.09633 16.6893 2.2844 16.796C2.47246 16.9028 2.68501 16.9589 2.90127 16.959Z"
          stroke="#F44336"
          strokeWidth="1.42182"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33426 7.16017L9.55848 11.9258L9.7823 7.16212C9.78369 7.13167 9.77884 7.10125 9.76807 7.07273C9.7573 7.04421 9.74083 7.01819 9.71966 6.99626C9.69849 6.97432 9.67307 6.95693 9.64496 6.94515C9.61684 6.93337 9.58662 6.92745 9.55613 6.92775C9.52618 6.92804 9.49659 6.93433 9.46911 6.94625C9.44164 6.95816 9.41682 6.97546 9.39614 6.99713C9.37546 7.01879 9.35933 7.04438 9.3487 7.07239C9.33807 7.10039 9.33316 7.13024 9.33426 7.16017Z"
          stroke="#F44336"
          strokeWidth="1.42182"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.55859 15.0449C9.40408 15.0449 9.25303 14.9991 9.12455 14.9133C8.99608 14.8274 8.89594 14.7054 8.83681 14.5626C8.77768 14.4199 8.76221 14.2628 8.79236 14.1113C8.8225 13.9597 8.89691 13.8205 9.00617 13.7112C9.11543 13.602 9.25463 13.5276 9.40618 13.4974C9.55773 13.4673 9.71481 13.4828 9.85757 13.5419C10.0003 13.601 10.1223 13.7012 10.2082 13.8296C10.294 13.9581 10.3398 14.1092 10.3398 14.2637C10.3398 14.4709 10.2575 14.6696 10.111 14.8161C9.96451 14.9626 9.76579 15.0449 9.55859 15.0449Z"
          fill="#F44336"
        />
      </g>
      <defs>
        <clipPath id="clip0_4459_7092">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NoteWarning;
